export const LOGOUT = 'logout';
export const LOGIN = 'login';

